// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyBqVOJqt26kXQ6kq9RaYl35HbH15db1T3U",
  authDomain: "order-clothes-2024-67ac4.firebaseapp.com",
  projectId: "order-clothes-2024-67ac4",
  storageBucket: "order-clothes-2024-67ac4.appspot.com",
  messagingSenderId: "520461057957",
  appId: "1:520461057957:web:8a9be626f5a3355fe8724c",
  measurementId: "G-8MGXFCRSHF",
  // apiKey: process.env.REACT_APP_API_KEY,
  // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_APP_ID,
  // measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
